import texts from "../assets/texts/texts";

export default function PopUp(view) {
 
  let popUp_buildings = {
    title: "RUIAN IBO: {RUIAN_IBO}",
    content: [
      {
        type: "fields",
        fieldInfos: [
          {
            fieldName: "PATA_VYSKA",
            label: texts.popup.PATA_VYSKA,
          },
          {
            fieldName: "HREBEN_VYSKA",
            label: texts.popup.HREBEN_VYSKA,
          },
          {
            fieldName: "ABS_VYSKA",
            label: texts.popup.ABS_VYSKA,
          },
          {
            fieldName: "HORIZ_VYSKA",
            label: texts.popup.HORIZ_VYSKA,
          },
          {
            fieldName: "STRECHA_KOD",
            label: texts.popup.STRECHA_KOD,
          },
          {
            fieldName: "PATA_SEG_VYSKA",
            label: texts.popup.PATA_SEG_VYSKA,
          },
          {
            fieldName: "abs_seg_vyska",
            label: texts.popup.abs_seg_vyska,
          },
          {
            fieldName: "ROK_POROZENI",
            label: texts.popup.ROK_POROZENI,
          },
        ],
      },
    ],
  };

   let popUp_trees = {
  title: "{taxon_nazev}",
  expressionInfos: [
    {
      name: "lat_name",
      title: texts.popupTree.name +" (lat)",
      expression: `
        var val = $feature.taxon_nazev;
        if (IsEmpty(val)) {
          return "${texts.popupTree.emptyValue}"
        }
        return val;
      `
    },
    {
      name: "cz_name",
      title: texts.popupTree.name + " (cz)",
      expression: `
        var val = $feature.taxon_nazev_cz;
        if (IsEmpty(val)) {
          return "${texts.popupTree.emptyValue}"
        }
        return val;
      `
    },
    {
        title: texts.popupTree.height,
      name: "vyska_taxonu",
      expression: `
        var val = $feature.vyska_taxonu;
        if (IsEmpty(val) || val==0) {
          return "${texts.popupTree.heightDefault}"
        }
        return "${texts.popupTree.heightPasport}"
      `
    }
  ],
  content: [
    {
      type: "fields",
      fieldInfos: [
        {
          fieldName: "expression/lat_name",
          label: texts.popupTree.name  + " (lat)"
        },
        {
          fieldName: "expression/cz_name",
          label: texts.popupTree.name  + " (cz)"
        },
                {
          fieldName: "expression/vyska_taxonu",
          label: texts.popupTree.height
        }
      ]
    }
  ]
};

view.when(()=>{
  
view.map.layers._items.find(o => o.title === texts.layers.buildings).popupTemplate = popUp_buildings

view.map.layers._items.find(o => o.title === texts.layers.trees).popupTemplate = popUp_trees
})
  

}
